type LoaderProps = {
	height?: number
	// use null color to disable the default color
	color?: string | null
}

export function MicroLoader({ height, color = '#fff' }: LoaderProps) {
	let styles = {}
	if (color === null) {
		styles = {}
	} else {
		styles = { '--loader-color': color } as React.CSSProperties
	}

	return (
		<div className="relative flex items-center justify-center w-8" style={{ height: height ?? 'auto' }}>
			<div className="loader" style={{ '--loader-color': color } as React.CSSProperties}></div>
		</div>
	)
}

export function SpinLoader() {
	return <div className="spin-loader" />
}
